import React from 'react';
import { useSelector } from 'react-redux';
import Reported from './Reported';
import Report from './Report';

export default function ReportScreenSwitch() {
  const step = useSelector((state) => state.report.step);
  const components = [Report, Reported];
  const CurrentPage = components[step - 1];
  return (
    <>
      <CurrentPage />
    </>
  );
}
